// src/components/mindworkout/sections/WorkoutReviewSection.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
    padding: 5rem 2rem;
    background: #f8f9fa;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const SectionTitle = styled.h2`
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 3rem;
    color: #333;
`;

const ReviewsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
`;

const ReviewCard = styled.div`
    background: white;
    padding: 2rem;
    border-radius: 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
`;

const ReviewHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

const Avatar = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${props => props.color};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    margin-right: 1rem;
`;

const ReviewerInfo = styled.div``;

const ReviewerName = styled.h4`
    font-size: 1.1rem;
    color: #333;
`;

const ReviewDate = styled.p`
    font-size: 0.9rem;
    color: #999;
`;

const Stars = styled.div`
    color: #FFD700;
    font-size: 1.2rem;
    margin-bottom: 1rem;
`;

const ReviewText = styled.p`
    color: #666;
    line-height: 1.6;
`;

const reviews = [
    {
        name: '김민수',
        date: '2024.05.15',
        rating: 5,
        text: 'ADHD가 있어서 집중이 어려웠는데, 이 앱으로 훈련하니 확실히 나아졌어요. 특히 SART 훈련이 도움이 많이 됐습니다.',
        color: '#4CAF50'
    },
    {
        name: '이서연',
        date: '2024.05.10',
        rating: 5,
        text: '게임처럼 재미있어서 매일 하게 돼요. 레벨 올리는 재미가 쏠쏠하고, 실제로 일상에서도 인내심이 늘어난 걸 느낍니다.',
        color: '#FF6B6B'
    },
    {
        name: '박준호',
        date: '2024.05.08',
        rating: 5,
        text: '감정조절이 어려웠는데 이 앱의 훈련들이 정말 도움이 됐어요. 화가 날 때 배운 호흡법을 쓰니 진짜 효과가 있더라고요.',
        color: '#9C27B0'
    }
];

const WorkoutReviewSection = () => {
    return (
        <SectionContainer>
            <ContentWrapper>
                <SectionTitle>사용자들의 생생한 후기</SectionTitle>
                <ReviewsGrid>
                    {reviews.map((review, index) => (
                        <ReviewCard key={index}>
                            <ReviewHeader>
                                <Avatar color={review.color}>
                                    {review.name[0]}
                                </Avatar>
                                <ReviewerInfo>
                                    <ReviewerName>{review.name}</ReviewerName>
                                    <ReviewDate>{review.date}</ReviewDate>
                                </ReviewerInfo>
                            </ReviewHeader>
                            <Stars>{'★'.repeat(review.rating)}</Stars>
                            <ReviewText>{review.text}</ReviewText>
                        </ReviewCard>
                    ))}
                </ReviewsGrid>
            </ContentWrapper>
        </SectionContainer>
    );
};

export default WorkoutReviewSection;
